import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="comments"
export default class extends Controller {
  static outlets = ["dropdown-photo"]
  static targets = ["dropdown", "button"]

  mainDropdownPhotoContainer = (this.hasDropdownTarget) ? this.dropdownTarget.firstElementChild : null

  connect() {
    if (this.hasDropdownTarget) {
      this.dropdownTarget.classList.add("hidden")
      this.addEventListenersToLinks()
    }

    if (this.hasButtonTarget) {
      this.buttonTarget.addEventListener("click", () => { this.buttonTarget.classList.toggle("bg-gray-100") })
    }

    this.disableAllLinks()
  }

  toggleDropdown(event) {
    event.preventDefault()

    this.dropdownTarget.classList.remove("hidden")

    const dropdownPhoto = this.findDropdownElement()
    const mainElement = dropdownPhoto.element

    // firstChild czyli element ktory widzimy na stronie zanim otworzymy dropdown w normalnych warunkach
    // ukrywamy go bo chcemy zeby po otwarciu dropdowna byl widoczny tylko element z dropdowna
    const firstChild = mainElement.firstElementChild.firstElementChild
    firstChild.classList.add("hidden")

    dropdownPhoto.open()
    dropdownPhoto.attachPopper()
    dropdownPhoto.element.querySelector("input").focus()
  }

  // znajdujemy konkretny dropdownPhoto, ktory jest podpiety pod nasz dropdown do komentarzy
  findDropdownElement() {
    return this.dropdownPhotoOutlets.find(element => {
      return element.element.parentElement === this.dropdownTarget
    })
  }

  // wylaczam wszystkie linki w dropdownie, poniewaz nie chcemy zeby po kliknieciu w link odpalalo sie bulk_action
  // dubluja sie wtedy requesty i ida dwa naraz
  disableAllLinks() {
    const links = this.findLinksFromDropdown()
    links.forEach(link => {
      link.href = "javascript:void(0)"
    })
  }

  // z racji, ze konstrukcja tego dropdownu jest taka, ze akcje sa wywolywane przez klikniecie w link
  // to musimy sluchac eventow na linkach
  findLinksFromDropdown() {
    if (this.hasDropdownTarget) {
      return this.dropdownTarget.querySelectorAll("li > a")
    } else {
      return []
    }
  }

  // do kazdego linka dodajemy listener, ktory tworzy i wysyla button odpowiedzialny za tworzenie komentarza i przypisanie go do usera
  addEventListenersToLinks() {
    const links = this.findLinksFromDropdown()
    links.forEach(link => {
      // link.addEventListener('click', this.submitButtonAndCloseDropdown.bind(this))
      if (link.dataset.action) {
        link.dataset.action += " click->comments#submitButtonAndCloseDropdown click->animated-dropdown#toggle"
      } else {
        link.dataset.action = "click->comments#submitButtonAndCloseDropdown click->animated-dropdown#toggle"
      }
    })
  }

  submitButtonAndCloseDropdown(e) {
    const dropdownPhoto = this.findDropdownElement()
    dropdownPhoto.toggle()

    // czasami wylapuje diva wewnatrz <a> a czasami <a> wiec musze sprawdzic ktory to jest
    if (e.target.dataset.value) {
      this.createAndSubmitNewButton(e.target.dataset.value)
    } else {
      this.createAndSubmitNewButton(e.target.parentElement.dataset.value)
    }

    // to jest workaround, poniewaz probowalem dolaczyc drugi outlet ktory odpowiada za dropdown w ktorym otwierany jest
    // dropdownPhoto, ale cos chyba z tym API jest jeszcze nie tak bo nie wylapuje tego kontrolera prawidlowo, wiec to jest
    // po to zeby zamknac dropdown po tym jak komentarz zostanie zapisany
    this.element.click()
    this.buttonTarget.classList.remove("bg-gray-100")
  }

  createAndSubmitNewButton(value) {
    if (value === undefined) {
      value = null
    }
    const button = document.createElement("button")
    const dropdownPhoto = this.findDropdownElement()
    button.type = "submit"
    button.name = this.buttonTarget.name
    button.classList.add("hidden")
    button.value = value

    dropdownPhoto.element.appendChild(button)

    button.click()
  }
}
